// Block-explorer URL builder. Pure helper — takes chainEnv as a param so
// @rmint/ui has zero coupling to apps/web's env module. The 'local'
// branch returns null because anvil/foundry has no explorer; callers
// degrade gracefully rather than crash.
//
// Phase 6.1 fixes a Sepolia bug: subscribe-fund-flow + subscribe-mint-
// confirmation hardcoded https://basescan.org (Base mainnet) but
// production runs at sepolia.invest.rmint.co with VITE_CHAIN_ENV=
// base-sepolia, so explorer links pointed to the wrong chain.

export type ChainEnv = 'local' | 'base-sepolia' | 'base';

const EXPLORER_BASE: Record<ChainEnv, string | null> = {
  base: 'https://basescan.org',
  'base-sepolia': 'https://sepolia.basescan.org',
  local: null,
};

export type ExplorerKind = 'tx' | 'address';

export function getExplorerUrl(
  chainEnv: ChainEnv,
  kind: ExplorerKind,
  value: string,
): string | null {
  const base = EXPLORER_BASE[chainEnv];
  return base ? `${base}/${kind}/${value}` : null;
}
